export default withSingleSubmit;

/**
 * @type {function(this: import('flightjs').ComponentAPI<
 * {
 *  submitButtonSelector: string,
 *  submitButtonLabelSelector: string,
 *  spinnerTargetSelector: string,
 *  submitButtonTextAttr: string,
 *  submitButtonEnableOn: string,
 *  autoSubmitForm: boolean
 * },
 * {
 *  disableButton: Function,
 *  enableButton: Function,
 *  addSpinner: Function,
 *  injectButtonDataReplacement: Function,
 *  activeBtn: JQuery,
 * }
 * >): void}
 */
function withSingleSubmit() {
    this.activeBtn = null;
    this.attributes({
        submitButtonSelector: '[data-single-submit]',
        submitButtonLabelSelector: '[data-button-label]',
        spinnerTargetSelector: '.button__inner',
        submitButtonTextAttr: 'data-single-submit',
        submitButtonEnableOn: 'uiEnableSubmit',
        autoSubmitForm: true,
    });

    this.after('initialize', function() {
        // Allow use of this.$node by checking for string vs obj
        if (typeof this.attr.submitButtonSelector === 'string') {
            this.on('click', { submitButtonSelector: this.disableButton });
        } else {
            this.on(this.$node, 'click', this.disableButton);
        }
        this.on(document, this.attr.submitButtonEnableOn, this.enableButton);
    });

    this.disableButton = function(e) {
        // do nothing if button is already disabled
        if (e.currentTarget.hasAttribute('disabled')) {
            return;
        }

        this.activeBtn = $(e.currentTarget);
        var $label = this.activeBtn.find(this.attr.submitButtonLabelSelector);

        this.activeBtn.attr('data-original-text', $label.text());
        this.activeBtn.attr('disabled', true).addClass('button--disabled');
        this.activeBtn.attr('data-loading', true);
        $label.html(this.activeBtn.attr(this.attr.submitButtonTextAttr));
        this.addSpinner();

        // Chrome behaviour is that a disabled button can't cause a submit
        // Because we've disabled the button, when the click event hits the <form>,
        // it's not considered a valid submit.
        // In FireFox it is, so the solution is to supress the click and manually fire submit
        //
        // This compromise drops the button's name=value data from the form data, so we emulate
        // that by injecting a hidden element with the same name=value
        e.preventDefault();
        this.injectButtonDataReplacement();

        if (this.attr.autoSubmitForm) {
            this.activeBtn.closest('form').submit();
        }
    };

    this.enableButton = function() {
        if (!this.activeBtn) {
            return;
        }
        if (this.activeBtn.data('original-text')) {
            this.activeBtn
                .find(this.attr.submitButtonLabelSelector)
                .html(this.activeBtn.data('original-text'));
        }
        this.activeBtn.removeAttr('disabled data-loading').removeClass('button--disabled');
        this.removeSpinner();

        this.removeButtonDataReplacement();
    };

    this.injectButtonDataReplacement = function() {
        // abort early
        if (this.activeBtn.attr('name') === undefined) {
            return;
        }
        this.activeBtn
            .closest('form')
            .append(
                '<input type="hidden" name="' +
                    this.activeBtn.attr('name') +
                    '" value="' +
                    this.activeBtn.attr('value') +
                    '">'
            );
    };

    this.removeButtonDataReplacement = function() {
        // abort early
        if (this.activeBtn.attr('name') === undefined) {
            return;
        }
        this.activeBtn
            .closest('form')
            .find('[type="hidden"][name="' + this.activeBtn.attr('name') + '"]')
            .remove();
    };

    this.addSpinner = function() {
        this.activeBtn.find('.button__icon').hide();
        $(
            '<span class="button__icon" data-spinner><span class="spinner spinner--small"></span></span>'
        ).appendTo(this.activeBtn.find(this.attr.spinnerTargetSelector));
    };

    this.removeSpinner = function() {
        this.activeBtn.find('[data-spinner]').remove();
        this.activeBtn.find('.button__icon').show();
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/mixins/with-single-submit.js